import { Component, input } from '@angular/core';
import { CarouselItemStyle, TutoStepContent } from '@shared/models';
import { SafePipe } from '@shared/pipes';

@Component({
  imports: [SafePipe],
  selector: 'b2c-variant4',
  styleUrl: './variant4.component.scss',
  templateUrl: './variant4.component.html',
})
export class Variant4Component {
  itemStyle = input.required<CarouselItemStyle>();
  stepContent = input.required<TutoStepContent>();
}
